import React, { useContext, useEffect, useState } from "react";
import { Link, NavLink, Route, Routes, useNavigate } from "react-router-dom";
import supp from "./assets/imgs/supp.png";
import logo from "./assets/images/login.png";
import employe from "./assets/imgs/employe.png";
import rendv from "./assets/imgs/rendezvous.png";
import patient from "./assets/imgs/patient.png";
import { deleteUser } from "./services/storage";
import { AppContext, initialUser } from "./services/context";
import Classe from "./pages/Classe";
import Matiere from "./pages/Matiere";
import Periode from "./pages/Periode";
import Eleve from "./pages/Eleve";
import Enseignant from "./pages/Enseignant";
import Parent from "./pages/Parent";
import MatiereClasse from "./pages/MatiereClasse";
import Chapitre from "./pages/Chapitre";
import Lecon from "./pages/Lecon";
import Cours from "./pages/Cours";
import Evaluation from "./pages/Evaluation";
import CoursEnLigne from "./pages/CoursEnLigne";
import Retour from "./Components/Retour";
import Role from "./pages/Role";
import Permission from "./pages/Permission";
import GroupeDroitUtilisateur from "./pages/utilisateur/GroupeDroitUtilisateur";
import UAdmin from "./pages/UAdmin";
import DroitAcces from "./pages/DroitAcces";
import Parametre from "./pages/Parametre";
import { MonCompte } from "./pages/MonCompte";
import ParametreApp from "./pages/ParametreApp";
import MessageDefilant from "./pages/MessageDefilant";
import Chatbot from "./pages/Chatbot";
import Home from "./pages/Home";
import StudentProgression from "./pages/StudentProgression";
import StudentProgressionSelector from "./pages/StudentProgressionSelector";

// Imports des interfaces d'abonnement
import SubscriptionPlansManager from "./pages/subscription/SubscriptionPlansManager";
import AdvancedSubscriptions from "./pages/subscription/AdvancedSubscriptions";
import MySubscription from "./pages/subscription/MySubscription";
import PaymentTransactionsManager from "./pages/subscription/PaymentTransactionsManager";
import PaymentReports from "./pages/subscription/PaymentReports";

// Import gestion offline
import OfflineBackup from "./pages/OfflineBackup";

import "./assets/css/dashboard-menu.css";
const Dashboard = () => {
  const authCtx = useContext(AppContext);
  const { user, onUserChange } = authCtx;
  const navigate = useNavigate();

  const tabMenu = [
    {
      droit: "view classe",
      url: "/dashboard/classes",
      display_name: "Classes",
      icon: "bi-building",
    },
    {
      droit: "view matiere",
      url: "/dashboard/matieres",
      display_name: "Matières",
      icon: "bi-book",
    },
    {
      droit: "view periode",
      url: "/dashboard/periodes",
      display_name: "Periodes",
      icon: "bi-calendar3",
    },
    {
      droit: "view matiereDeLaclasse",
      url: "/dashboard/matieres-d-une-classe",
      display_name: "Matières d'une classe",
      icon: "bi-collection",
    },
    {
      droit: "view chapitre",
      url: "/dashboard/chapitres",
      display_name: "Sections",
      icon: "bi-bookmark",
    },
    {
      droit: "view lecon",
      url: "/dashboard/lecons",
      display_name: "Leçons",
      icon: "bi-journal-text",
    },
    {
      droit: "view evaluation",
      url: "/dashboard/evaluations",
      display_name: "Evaluations",
      icon: "bi-clipboard-check",
    },
    {
      droit: "view discussion",
      url: "/dashboard/discussions",
      display_name: "Discussions",
      icon: "bi-chat-dots",
    },
    {
      droit: "view classeVirtuelle",
      url: "/dashboard/cours-en-ligne",
      display_name: "Classes Virtuelles",
      icon: "bi-camera-video",
    },
    {
      droit: "view classeVirtuelle", // a revoir
      url: "/dashboard/chatbot",
      display_name: "Chatbot",
      icon: "bi-robot",
    },
    {
      droit: "view eleve",
      url: "/dashboard/eleves",
      display_name: "Élèves",
      icon: "bi-people",
    },
    {
      droit: "view enseignant",
      url: "/dashboard/enseignants",
      display_name: "Enseignants",
      icon: "bi-person-badge",
    },
    {
      droit: "view parent",
      url: "/dashboard/parents",
      display_name: "Parents",
      icon: "bi-person-hearts",
    },
    {
      droit: "view progression",
      url: "/dashboard/progression-eleve",
      display_name: "Progression Élèves",
      icon: "bi-graph-up-arrow",
    },
    {
      droit: "view utilisateur",
      url: "/dashboard/utilisateurs",
      display_name: "Utilisateurs",
      icon: "bi-person-gear",
    },
    {
      droit: "view utilisateur",
      //droit: "view offline",
      url: "/dashboard/sauvegardes-offline",
      display_name: "Sauvegardes Offline",
      icon: "bi-cloud-download",
      //isSystemSection: true,
    },
    {
      droit: "view parametre",
      url: "/dashboard/parametres",
      display_name: "Paremètres",
      icon: "bi-gear",
    },
    // Section Abonnements
    /*{
      droit: "view subscription plans",
      url: "/dashboard/formules-abonnement",
      display_name: "Formules d'abon.",
      icon: "bi-tags",
      isSubscriptionSection: true,
    },
    {
      droit: "view subscriptions",
      url: "/dashboard/abonnements",
      display_name: "Abonnements",
      icon: "bi-person-check",
      isSubscriptionSection: true,
    },
    {
      droit: "view subscriptions",
      url: "/dashboard/transactions-paiement",
      display_name: "Transactions",
      icon: "bi-credit-card",
      isSubscriptionSection: true,
    },
    {
      droit: "view reports",
      url: "/dashboard/analyses-abonnements",
      display_name: "Rapports Financiers",
      icon: "bi-graph-up",
      isSubscriptionSection: true,
    },
    {
      droit: "view my subscription",
      url: "/dashboard/mon-abonnement",
      display_name: "Mon Abonnement",
      icon: "bi-person-check-fill",
      isSubscriptionSection: true,
    },*/
  ];

  useEffect(() => {
    isAuth();
  }, [user.isAuth]);

  const isAuth = () => {
    if (user.isAuth == false || user.token == null || user.token == "") {
      console.log(`connexion échoué, isAuth`);
      console.log(user);

      return navigate("/");
    } else {
      console.log("isAuth true");
    }
  };

  const deconnect = () => {
    deleteUser();
    onUserChange(initialUser);
  };

  return (
    <>
      <header className="container-fluid navbar navbar-dark bg-white sticky-top1 flex-md-nowrap px-0 py-2 shadow1 d-md-none">
        <div className="d-flex align-items-center justify-content-between w-100">
          <a className="navbar-brand1 bg-white me-auto px-3" href="#">
            <img width="64px" src={logo} alt="" />
          </a>
          <button
            className="navbar-toggler ms-auto mx-0 d-md-none collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#sidebarMenu"
            aria-controls="sidebarMenu"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i className="bi bi-list text-primary icon-size"></i>
          </button>
        </div>
      </header>

      <div className="container-fluid">
        <div className="row">
          <nav
            id="sidebarMenu"
            className="col-md-1 col-lg-2 d-md-block bg-white sidebar overflow-y-scroll collapse p-0"
          >
            <div className="position-sticky h-100 text-small">
              <div className="col-12 d-none d-md-block text-center pt-4 pb-2 m-0">
                <img width={"30%"} src={logo} alt="" />
              </div>
              <div className="d-md-none py-2"></div>
              <ul className="nav flex-column">
                <li className="nav-item my-1 px-2">
                  <NavLink
                    to="/dashboard/"
                    className={({ isActive }) =>
                      isActive
                        ? "nav-link active btn btn-primary border rounded-2 mx-auto py-0 text-start pt-1"
                        : "btn nav-link border-0 py-0 btn-secondary text-start pt-1"
                    }
                  >
                    <span className="d-none d-md-block d-lg-none wd-0">
                      <i className="bi bi-house-door fs-5"></i>
                    </span>
                    <span
                      className="d-block d-md-none d-lg-block wd-80"
                      data-bs-toggle="collapse"
                      data-bs-target="#sidebarMenu.show"
                    >
                      <i className="bi bi-house-door me-2"></i>
                      Accueil
                    </span>
                  </NavLink>
                </li>
                
                {/* Section Gestion Pédagogique */}
                {tabMenu.filter(item => !item.isSubscriptionSection && user.permissions?.includes(item.droit)).length > 0 && (
                  <li className="nav-item px-2 mt-3 mb-2">
                    <small className="text-muted text-uppercase fw-bold d-block d-md-none d-lg-block">
                      Gestion Pédagogique
                    </small>
                  </li>
                )}
                
                {tabMenu.filter(item => !item.isSubscriptionSection).map((data, idx) => {
                  if (!user.permissions?.includes(data.droit)) {
                    return null;
                  }
                  return (
                    <li className="nav-item my-1 px-2" key={idx}>
                      <NavLink
                        to={data.url}
                        className={({ isActive }) =>
                          isActive
                            ? "nav-link active btn btn-primary border rounded-2 mx-auto py-0 text-start pt-1"
                            : "btn nav-link border-0 py-0 btn-secondary text-start pt-1"
                        }
                      >
                        <span className="d-none d-md-block d-lg-none wd-0">
                          <i className={`${data.icon} fs-5`}></i>
                        </span>
                        <span
                          className="d-block d-md-none d-lg-block wd-80 p-0 m-0"
                          data-bs-toggle="collapse"
                          data-bs-target="#sidebarMenu.show"
                        >
                          <i className={`${data.icon} me-2`}></i>
                          {data.display_name}
                        </span>
                      </NavLink>
                    </li>
                  );
                })}

                {/* Section Abonnements */}
                {(user.permissions?.includes('view subscription plans') || user.permissions?.includes('view subscriptions')) && (
                  <>
                    <li className="nav-item px-2 mt-4 mb-2">
                      <small className="text-muted text-uppercase fw-bold d-block d-md-none d-lg-block">
                        <i className="bi bi-credit-card-2-front me-1"></i>
                        Abonnements
                      </small>
                    </li>
                    
                    {tabMenu.filter(item => item.isSubscriptionSection).map((data, idx) => (
                      <li className="nav-item my-1 px-2" key={`sub-${idx}`}>
                        <NavLink
                          to={data.url}
                          className={({ isActive }) =>
                            isActive
                              ? "nav-link active btn btn-primary border rounded-2 mx-auto py-0 text-start pt-1"
                              : "btn nav-link border-0 py-0 btn-secondary text-start pt-1"
                          }
                        >
                          <span className="d-none d-md-block d-lg-none wd-0">
                            <i className={`${data.icon} fs-5`}></i>
                          </span>
                          <span
                            className="d-block d-md-none d-lg-block wd-80 p-0 m-0"
                            data-bs-toggle="collapse"
                            data-bs-target="#sidebarMenu.show"
                          >
                            <i className={`${data.icon} me-2`}></i>
                            {data.display_name}
                          </span>
                        </NavLink>
                      </li>
                    ))}
                  </>
                )}

                {/* Section Système */}
                {user.permissions?.includes('view offline') && (
                  <>
                    <li className="nav-item px-2 mt-4 mb-2">
                      <small className="text-muted text-uppercase fw-bold d-block d-md-none d-lg-block">
                        <i className="bi bi-gear-wide-connected me-1"></i>
                        Système
                      </small>
                    </li>
                    
                    {tabMenu.filter(item => item.isSystemSection).map((data, idx) => (
                      <li className="nav-item my-1 px-2" key={`sys-${idx}`}>
                        <NavLink
                          to={data.url}
                          className={({ isActive }) =>
                            isActive
                              ? "nav-link active btn btn-primary border rounded-2 mx-auto py-0 text-start pt-1"
                              : "btn nav-link border-0 py-0 btn-secondary text-start pt-1"
                          }
                        >
                          <span className="d-none d-md-block d-lg-none wd-0">
                            <i className={`${data.icon} fs-5`}></i>
                          </span>
                          <span
                            className="d-block d-md-none d-lg-block wd-80 p-0 m-0"
                            data-bs-toggle="collapse"
                            data-bs-target="#sidebarMenu.show"
                          >
                            <i className={`${data.icon} me-2`}></i>
                            {data.display_name}
                          </span>
                        </NavLink>
                      </li>
                    ))}
                  </>
                )}
              </ul>

              <ul className="nav flex-column w-100 position-absolute1 bottom-0 mb-2">
                <li className="nav-item my-1 px-2">
                  <NavLink
                    to={"/dashboard/user-compte"}
                    className={({ isActive }) =>
                      isActive
                        ? "nav-link active btn btn-primary border rounded-2 mx-auto py-0 text-start pt-1"
                        : "btn nav-link border-0 py-0 btn-secondary text-start pt-1"
                    }
                  >
                    <span className="d-none d-md-block d-lg-none wd-0">
                      <i className="bi bi-person-circle fs-5"></i>
                    </span>
                    <span
                      className="d-block d-md-none d-lg-block wd-80 p-0 m-0"
                      data-bs-toggle="collapse"
                      data-bs-target="#sidebarMenu.show"
                    >
                      <i className="bi bi-person-circle me-2"></i>
                      Mon compte
                    </span>
                  </NavLink>
                </li>
                <li className="nav-item my-1 px-2">
                  <span
                    className="btn nav-link border-0 py-0 btn-danger text-start pt-1 cursor-pointer"
                    onClick={deconnect}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => e.key === 'Enter' && deconnect()}
                  >
                    <span className="d-none d-md-block d-lg-none wd-0">
                      <i className="bi bi-box-arrow-right fs-5"></i>
                    </span>
                    <span className="d-block d-md-none d-lg-block">
                      <i className="bi bi-box-arrow-right me-2"></i>
                      Se déconnecter
                    </span>
                  </span>
                </li>
              </ul>
            </div>
          </nav>

          <main className="col-md-11 ms-sm-auto col-lg-10 px-md-4 h-90 text-small bg-primary-light1">
            <div className="sticky-top my-4">
              <Retour />
            </div>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/classes" element={<Classe />} />
              <Route path="/matieres" element={<Matiere />} />
              <Route
                path="/matieres-d-une-classe"
                element={<MatiereClasse />}
              />
              <Route path="/chapitres" element={<Chapitre />} />
              <Route path="/lecons/*" element={<Lecon />} />
              <Route path="/cours/*" element={<Cours />} />
              <Route path="/evaluations/*" element={<Evaluation />} />
              <Route path="/cours-en-ligne/*" element={<CoursEnLigne />} />
              <Route path="/chatbot" element={<Chatbot />} />
              <Route path="/periodes" element={<Periode />} />
              <Route path="/eleves/*" element={<Eleve />} />
              <Route path="/enseignants/*" element={<Enseignant />} />
              <Route path="/parents" element={<Parent />} />
              <Route path="/progression-eleve" element={<StudentProgressionSelector />} />
              <Route path="/progression-eleve/:eleveId" element={<StudentProgression />} />
              <Route path="/u-admin" element={<UAdmin />} />
              <Route path="/user-compte" element={<MonCompte />} />
              <Route path="/parametres" element={<Parametre />} />
              <Route path="/variables-application" element={<ParametreApp />} />
              <Route path="/messages-defilants" element={<MessageDefilant />} />
              <Route path="/utilisateurs" element={<DroitAcces />} />
              <Route
                path="/groupe-droits-utilisateur/:slug"
                element={<GroupeDroitUtilisateur />}
              />
              <Route path="/groupes-utilisateurs/*" element={<Role />} />
              <Route path="/droits-access" element={<Permission />} />
              
              {/* Routes d'abonnement */}
              <Route path="/formules-abonnement" element={<SubscriptionPlansManager />} />
              <Route path="/abonnements" element={<AdvancedSubscriptions />} />
              <Route path="/mon-abonnement" element={<MySubscription />} />
              <Route path="/transactions-paiement" element={<PaymentTransactionsManager />} />
              <Route path="/analyses-abonnements" element={<PaymentReports />} />
              
              {/* Routes Système */}
              <Route path="/sauvegardes-offline" element={<OfflineBackup />} />
              
              <Route path="/parametre" element={<>Paramètres</>} />
            </Routes>
          </main>
          <div className="col-md-9 ms-sm-auto col-lg-10 px-md-4 bg-body-tertiary">
            <div className="text-small d-inline-block my-4 me-4">
              Copyright © 2025 ENUMERA
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
